module.exports = __webpack_public_path__ + "static/media/background.0478a0e0.jpg";